/**
 * Trunnion AI - Empty State Component
 */

import type { ReactNode } from 'react';
import { Inbox } from 'lucide-react';

interface EmptyStateProps {
  icon?: ReactNode;
  message: string;
  description?: string;
  action?: ReactNode;
}

export function EmptyState({
  icon,
  message,
  description,
  action,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center">
      <div className="mb-4 text-trunnion-slate-500">
        {icon ?? <Inbox className="h-12 w-12" />}
      </div>
      <h3 className="text-base font-medium text-trunnion-slate-200">{message}</h3>
      {description && (
        <p className="mt-1.5 max-w-sm text-sm text-trunnion-slate-400">
          {description}
        </p>
      )}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
